<template>
  <div class="pt-5">
    <v-data-table
      :items="emisiones"
      :headers="headers"
      :loading="loading"
      :server-items-length="totalItems"
      :items-per-page="pagination.itemsPerPage"
      :page="pagination.page"
      no-data-text="Sin renovaciones pendientes para mostrar"
      loading-text="Cargando..."
      :footer-props="{
        'items-per-page-options': [5, 10, 25, 50],
        'items-per-page-text': 'Elementos por página',
      }"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
    >
      <template v-slot:top>
        <v-row style="padding: 15px">
          <v-col cols="12" md="8">
            <h2>Resultados de la búsqueda</h2>
          </v-col>
        </v-row>
      </template>

      <template #item.ver="{ item }">
        <v-btn icon x-small @click="verEmision(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>

      <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
        <div v-if="itemsLength">
          Mostrando {{ pageStart }} - {{ pageStop }} de
          {{ itemsLength }} renovaciones pendientes
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    emisiones: Array,
    loading: Boolean,
    totalItems: Number,
    pagination: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: "ID", value: "id" },
        { text: "Titular", value: "titular" },
        { text: "Producto aseguradora", value: "productoAseguradora" },
        { text: "Poliza", value: "poliza" },
        { text: "Poliza aseguradora", value: "polizaAseguradora" },
        { text: "Fecha emision", value: "fechaEmision" },
        { text: "Fecha inicio", value: "inicio" },
        { text: "Fecha fin", value: "fin" },
        { text: "Estatus", value: "statusNombre" },

        { text: "Ver", value: "ver" },
      ],
    };
  },
  methods: {
    verEmision(emision) {
      this.$router.push(`/emision/${emision.id}`);
    },

    onPageChange(newPage) {
      this.$emit("update:pagination", { ...this.pagination, page: newPage });
    },
    onItemsPerPageChange(newSize) {
      this.$emit("update:pagination", {
        ...this.pagination,
        itemsPerPage: newSize,
        page: 1,
      });
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #fcf2f2;
  border-radius: 20px;
}
</style>
